import { render } from "./QuestionsMultiChoice.vue?vue&type=template&id=56d1701a"
import script from "./QuestionsMultiChoice.vue?vue&type=script&lang=js"
export * from "./QuestionsMultiChoice.vue?vue&type=script&lang=js"

import "./QuestionsMultiChoice.vue?vue&type=style&index=0&id=56d1701a&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__